<template>
  <div class="onboarding_comp auth-input-page">
    <div class="auth-input-page__group">
      <label class="auth-label-input">Full Name</label>
      <input
        v-model="fullName"
        :class="{ _filled: fullName }"
        type="text"
        placeholder="Your full name"
      />
    </div>

    <div class="auth-input-page__group my-1">
      <label class="auth-label-input">Email</label>
      <input
        v-model="email"
        :class="{ _filled: email }"
        type="email"
        placeholder="Your email"
      />
    </div>

    <div class="auth-input-page__group">
      <label class="auth-label-input">Password</label>
      <input v-model="password" type="password" placeholder="Your password" />
    </div>

    <div
      :class="{
        'display-flex align-center gap-8 justify-space-between':
          $vuetify.breakpoint.width <= 1280,
      }"
    >
      <v-btn
        v-if="$vuetify.breakpoint.width <= 1280"
        class="back-button"
        @click="$emit('actionPrevStage')"
      >
        Back
      </v-btn>
      <v-btn
        :class="{
          _disabled: !validated('skipToast'),
          'auth-bg-disabled': checkDataEmpty,
          'auth-bg-active': !checkDataEmpty,
        }"
        class="auth-button"
        @click="handleNextStage()"
      >
        Next
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import AuthService from "@/services/auth";

export default {
  data() {
    return {
      fullName: "",
      email: "",
      password: "",
    };
  },
  computed: {
    ...mapState({
      current: (state) => state.app.onboarding.current,
      getFullName: (state) => state.app.onboarding.fullName,
      getEmail: (state) => state.app.onboarding.email,
      getPassword: (state) => state.app.onboarding.password,
    }),
    checkDataEmpty() {
      return this.fullName == "" || this.email == "" || this.password == "";
    },
  },
  methods: {
    ...mapActions({
      gotoNextStage: "app/nextOnboardingStage",
      gotoPrevStage: "app/prevOnboardingStage",
    }),
    ...mapMutations({
      updateOnboarding: "app/updateOnboarding",
    }),
    validated(toastStatus) {
      const skipToast = toastStatus === "skipToast";

      const { fullName, email, password } = this;
      const valEmail = this.validateEmail(email);
      const toValidate = [valEmail];

      const errors = [
        "Please enter a valid email address",
      ];

      const isValid = toValidate.every((item, index) => {
        if (!skipToast && !item) {
          this.$store.dispatch("error/showErrorToast", [errors[index]]);
          return item;
        }
        return item;
      });
      return isValid;
    },
    validateEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    validatePassword(password) {
      if (
        /^(?=\S*[a-z])(?=\S*[A-Z])(?=\S*\d)(?=\S*([^\w\s]|[_]))\S{8,}$/.test(
          password
        )
      ) {
        return true;
      }
      return false;
    },
    async handleNextStage() {
      let isEmailAvailable = false;
      await AuthService.isEmailAvailable({ email: this.email })
        .then((res) => {
          isEmailAvailable = true;
        })
        .catch((e) => {
          this.$store.dispatch("error/showErrorToast", ["Email already exist"]);
          isEmailAvailable = false;
        });

      if (this.validated() && isEmailAvailable) {
        const data = {
          fullName: this.fullName,
          first_name: this.fullName.split(" ").slice(0, 1).join(" "),
          last_name: this.fullName
            .split(" ")
            .slice(1, this.fullName.length)
            .join(" "),
          email: this.email,
          password: this.password,
        };
        this.updateOnboarding(data);

        this.gotoNextStage(this.current + 1);
      }
    },
    handlePrevStage() {
      if (this.current !== 1) {
        this.gotoPrevStage(this.current - 1);
      }
    },
  },
  created() {
    this.fullName = this.getFullName;
    this.email = this.getEmail;
    this.password = this.getPassword;
  },
};
</script>

<style lang="scss" scoped>
.auth-input-page {
  &__group {
    display: flex;
    flex-direction: column;
    width: 354px;
  }
}
.auth-button {
  margin: 30px 0 0 !important;
  box-shadow: none !important;
  width: 100%;
}

.back-button {
  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
  line-height: 18.68px;
  text-align: center;
  background: #0000000d;
  height: 50px;
  border-radius: 56px;
  margin: 30px 0 0 !important;
  box-shadow: none !important;
  width: 100%;
}

@media screen and (max-width: 1280px) {
  .auth-button {
    height: 50px !important;
    border-radius: 56px;
    font-size: 18px !important;
  }
}
</style>



// WEBPACK FOOTER //
// accountInfo.vue?2412b0ee